import { render, staticRenderFns } from "./marketReference.vue?vue&type=template&id=4c551742&scoped=true"
import script from "./marketReference.vue?vue&type=script&lang=js"
export * from "./marketReference.vue?vue&type=script&lang=js"
import style0 from "./marketReference.vue?vue&type=style&index=0&id=4c551742&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c551742",
  null
  
)

export default component.exports